import React from "react";
import { Box, Typography } from "@mui/material";

const FormField = ({ 
  label, 
  required = false, 
  children, 
  fullWidth = false,
  error = false,
  helperText = "",
  sx = {}
}) => (
  <Box sx={{ marginBottom: 3, ...sx }}>
    <Typography 
      variant="body2" 
      sx={{ 
        marginBottom: 1, 
        fontWeight: 500,
        color: error ? "error.main" : "text.primary"
      }}
    >
      {label}
      {required && <span style={{ color: "error.main" }}>*</span>}
    </Typography>
    <Box sx={{ width: fullWidth ? "100%" : "auto" }}>
      {children}
    </Box>
    {helperText && (
      <Typography 
        variant="caption" 
        sx={{ 
          marginTop: 0.5, 
          color: error ? "error.main" : "text.secondary",
          display: "block"
        }}
      >
        {helperText}
      </Typography>
    )}
  </Box>
);

export default FormField;